<template>
  <div :class="`page-banner-area ${bannerHeight}`" :style="{ backgroundImage: `url(${bannerImage})` }">
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <div class="page-banner-content text-center">
            <h4 class="breadcrumb-title">{{ title }}</h4>
            <div class="breadcrumb-two">
              <nav>
                <nav class="breadcrumb-trail breadcrumbs">
                  <ul class="breadcrumb-menu">
                    <li class="breadcrumb-trail">
                      <router-link to="/"><span>Home</span></router-link>
                    </li>
                    <li class="trail-item">
                      <span>{{ subtitle }}</span>
                    </li>
                  </ul>
                </nav>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cartbanner from '@/assets/images/banner/page-banner-4.jpg'
export default {
  name: "BreadcrumbOne",
  props: {
    bannerHeight: {
      type: String,
      default: "page-banner-height-2",
    },
    // Dynamic banner image URL (from CMS). Falls back to the bundled asset.
    banner: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
  },
  computed: {
    bannerImage() {
      return this.banner && this.banner.length > 0 ? this.banner : this.fallback
    },
  },
  data() {
    return {
      fallback: cartbanner,
    }
  },
};
</script>